import AreaChart from './Area';
import BarChart from './Bar';
import DoughnutChart from './Doughnut';
import LineChart from './Line';
import PieChart from './Pie';
import PolarAreaChart from './PolarArea';
import RadarChart from './Radar';
import ScatterChart from './Scatter';
import SmallLineChart from './SmallLine';

export {
  AreaChart,
  BarChart,
  DoughnutChart,
  LineChart,
  PieChart,
  PolarAreaChart,
  RadarChart,
  ScatterChart,
  SmallLineChart,
};
